import React from 'react';
import SubnavItem from '@molecules/SubnavItem';
import ThirdLevelSubnavItem from "@molecules/ThirdLevelSubnavItem";
import PropTypes from 'prop-types';


const AccountSettingsSubnav = ({ viewer }) => {
    const isOfficial = viewer && viewer.official;

    return (
        <>
            <SubnavItem label="Account Preferences" to="/my-icsc/account/preferences" />
            <SubnavItem label="Edit Profile" to="/my-icsc/account/edit-profile/">
                <ThirdLevelSubnavItem label="Basic Information" to="/my-icsc/account/edit-profile/basic" />
                <ThirdLevelSubnavItem label="Contact Information" to="/my-icsc/account/edit-profile/contact" />
                <ThirdLevelSubnavItem label="Education & Employment" to="/my-icsc/account/edit-profile/education" />
            </SubnavItem>

            {/* Only show Edit Company Profile if viewer.official is true */}
            {isOfficial && <SubnavItem to="/my-icsc/account/edit-company" label="Edit Company Profile" />}

            <SubnavItem to="/my-icsc/account/update-password" label="Update Password" />

            <SubnavItem label="Billing & Payments" to="/my-icsc/account/edit-billing/">
                <ThirdLevelSubnavItem label="Payment History" to="/my-icsc/account/edit-billing/payment-history" />
                <ThirdLevelSubnavItem label="Payment Preferences" to="/my-icsc/account/edit-billing/payment-preferences" />
                <ThirdLevelSubnavItem label="Auto-Renew Membership" to="/my-icsc/account/edit-billing/auto-renew" />
            </SubnavItem>
        </>
    );
};

AccountSettingsSubnav.propTypes = {
    viewer: PropTypes.shape({
        official: PropTypes.bool.isRequired,
    }),
};

export default AccountSettingsSubnav;
